export default __webpack_public_path__ + "static/media/photo_5282747746622312930_y.fc4a4932.jpg";